import "./widget.css";
import Header from "../../layout/Header/Header";
import ScheduleTestDrive from "../ScheduleTestDrive/ScheduleTestDrive";
import ManageTestDrive from "../ManageTestDrive/ManageTestDrive";
import Loader from "../../components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setTestDrives,
  setToReschedule,
  setUserTestDriveInfo
} from "../../redux-sagas/actions";
import { getTranslation } from "../../utils/getTranslation";
import { useTranslation } from "react-i18next";
import ThemeOverride from "./ThemeOverride";
import DynamicIcon from "../../components/Icons/DynamicIcon";

const Widget = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentPage = useSelector((state) => state.currentPage);
  const isLoading = useSelector((state) => state.isLoading);
  const settings = useSelector((state) => state.settings);

  const strokeColor = currentPage !== "test-drives" 
    ? getComputedStyle(document.querySelector("body")).getPropertyValue("--primary") 
    : '#fff';

  return (
    <ThemeOverride>
      <div className="widget">
        <Header currentPage={currentPage} />
        <div className="container p-0">
          <nav>
            <ul className="ulBox">
              <li
                className={`${currentPage === "schedule" ? "selected" : "unselected"
                  }`}
                onClick={() => {
                  dispatch(setCurrentPage("schedule"));
                  dispatch(setUserTestDriveInfo({}));
                }}
              >
                <DynamicIcon name="calendar" fill="currentColor" stroke="none" width="22px" />
                <span>{getTranslation("schedule_test_drive_tab", t)}</span>
              </li>
              <li
                className={`${currentPage === "test-drives" ? "selected" : "unselected"
                  }`}
                onClick={() => {
                  dispatch(setCurrentPage("test-drives"));
                  dispatch(setToReschedule(null));
                  dispatch(setTestDrives({ data: [] }));
                  dispatch(setUserTestDriveInfo({}));
                }}
              >
                <DynamicIcon name='clipboard' fill="currentColor" stroke="none" />
                <span>{getTranslation("my_test_drives_title_tab", t)}</span>
              </li>
            </ul>
          </nav>
          {currentPage === "test-drives" && (
            <div className="mobileHeader">
              <h2>
                {getTranslation("my_test_drives_title", t)}
              </h2>
              <span>{getTranslation("consult___reschedule_and_or_cancel_your_test_drive_subtitle", t)}
              </span>
            </div>
          )}
          <div className="main-cont">
            {
              settings && (
                currentPage === "schedule" ? (
                  <ScheduleTestDrive />
                ) : (
                  <ManageTestDrive />
                )
              )
            }
            {isLoading && <Loader />}
          </div>
        </div>
      </div>
    </ThemeOverride>
  );
};

export default Widget;
